import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { FadeLoader } from "react-spinners";
import * as actions from "../../store/actions";
import Button from "../../components/CustomButtons/Button.jsx";
import UserHistoryViewDialog, { statusLabels } from "../../views/Pages/UserHistoryViewDialog";

const UserAdminHistory = (props) => {
    const { userId, userHistory, userHistoryLoading, getUserHistory } = props;
    const [viewEntry, setViewEntry] = useState(null);
    const [viewOpen, setViewOpen] = useState(false);

    useEffect(() => {
        getUserHistory();
    }, []);

    const all = Array.isArray(userHistory) ? userHistory : [];
    const filtered = userId
        ? all.filter(h => String(h.user_id) === String(userId))
        : all;

    return (
        <div style={{ marginTop: 10 }}>
            {userHistoryLoading && (
                <div style={{ textAlign: "center", padding: 30 }}>
                    <FadeLoader />
                </div>
            )}
            {!userHistoryLoading && (
                <ReactTable
                    filterable
                    data={filtered.map((entry) => {
                        let userName = entry.user_name;
                        if (!userName) {
                            try {
                                const d = typeof entry.data === 'string' ? JSON.parse(entry.data) : entry.data;
                                if (d && d.firstname && d.lastname) userName = d.firstname + ' ' + d.lastname;
                                else if (d && d.name) userName = d.name;
                            } catch(e) {}
                        }
                        return {
                            id: entry.id,
                            date: new Date(entry.timestamp).toLocaleString(),
                            timestamp: entry.timestamp,
                            submitter: entry.submitter_name || 'N/A',
                            user: userName || 'N/A',
                            status: statusLabels[entry.status] || entry.status,
                            actions: (
                                <Button color="primary" size="sm" onClick={() => {
                                    setViewEntry(entry);
                                    setViewOpen(true);
                                }}>View</Button>
                            )
                        };
                    })}
                    columns={[
                        {
                            Header: "Date",
                            accessor: "date",
                            sortMethod: (a, b) => new Date(a) - new Date(b),
                            filterMethod: (filter, row) => row[filter.id].toLowerCase().indexOf(filter.value.toLowerCase()) !== -1
                        },
                        {
                            Header: "Submitter",
                            accessor: "submitter",
                            filterMethod: (filter, row) => row[filter.id].toLowerCase().indexOf(filter.value.toLowerCase()) !== -1
                        },
                        {
                            Header: "Action",
                            accessor: "status",
                            filterMethod: (filter, row) => row[filter.id].toLowerCase().indexOf(filter.value.toLowerCase()) !== -1
                        },
                        {
                            Header: "Actions",
                            accessor: "actions",
                            sortable: false,
                            filterable: false
                        }
                    ]}
                    defaultPageSize={10}
                    showPaginationTop
                    showPaginationBottom={false}
                    className="-striped"
                    defaultSorted={[{ id: "date", desc: true }]}
                />
            )}
            {!userHistoryLoading && filtered.length === 0 && (
                <div style={{ textAlign: "center", padding: 20, color: "#888" }}>
                    No history entries for this user yet.
                </div>
            )}
            {viewOpen && (
                <UserHistoryViewDialog
                    open={viewOpen}
                    close={() => { setViewOpen(false); setViewEntry(null); }}
                    entry={viewEntry}
                />
            )}
        </div>
    );
};

const mapStateToProps = (state) => ({
    userHistory: state.user.userHistory,
    userHistoryLoading: state.user.userHistoryLoading
});

const mapDispatchToProps = (dispatch) => ({
    getUserHistory: () => dispatch(actions.getUserHistory())
});

export default connect(mapStateToProps, mapDispatchToProps)(UserAdminHistory);
